import { z } from "zod";
import {
  ADVANCE_SCOPES,
  ADVANCE_STATUSES,
} from "@/features/expenses/schemas/employee-advance.schema";

/**
 * URL search params for `/$slug/expenses/advances` (HRMS-EXP-012).
 *
 * The same scope law the claims page follows, and the same three lenses, for
 * the same reason: `mine` is my own advances, `team` is the ones routed to me
 * to decide, `workspace` is every one of them. There is no `setup` here
 * because an advance has no catalog.
 *
 * `status` rides the URL rather than component state (S3) because the balance
 * card links to it: "2 awaiting approval" is a link to this page filtered, and
 * a filter that cannot be addressed is a figure that cannot be clicked.
 *
 * Both are `.catch(...)` rather than throwing: a bad value in a pasted link
 * should show the default view, not an error page about a query string.
 */
export const advancesRouteSearchSchema = z
  .object({
    scope: z.enum(ADVANCE_SCOPES).catch("mine").default("mine"),
    status: z.enum(ADVANCE_STATUSES).optional().catch(undefined),
  })
  .strict();
export type AdvancesRouteSearch = z.infer<typeof advancesRouteSearchSchema>;
